import axios from 'axios';
import internals from '../config/internals';
import httpConfig, { isProdReturn } from './httpConfig';

const httpService = axios.create({
  baseURL: isProdReturn(internals.url_api, '/api'),
});

httpConfig(httpService);

export default httpService;
